<template>
  <div class="row">
    <!--
    <div class="col-4">
      Choose Metal
    </div>
    -->
    <div class="col-12 selectjewelry">
      <el-form :model="model" :rules="rules" ref="form">
        <el-form-item prop="metal">
          <input type="hidden" v-model="model.metal" value=""/>

            <div :class="rootClass">
              <ul :class="`${rootClass}__wrapper`">
                <li v-for="(dataImage, index) in dataImages" :key="index" :class="`${rootClass}__item`">
                  <div :id="`m${dataImage.id}`"
                    :class="classThumbnailMultiple(dataImage.id, dataImage.metalclass, dataImage.disabled)"
                    @click="onSelectMultipleImage(dataImage)"
                  >
                    <img
                      :src="dataImage.src"
                      :alt="dataImage.alt"
                      :id="dataImage.id"
                      :height="h"
                      :width="w"
                      :class="`${rootClass}__img`"
                    />
                    <label :for="dataImage.id" :class="`${rootClass}__lbl`">{{dataImage.alt}}</label>
                  </div>
                </li>
              </ul>
            </div>

        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// add stylesheet
require('vue-select-image/dist/vue-select-image.css')

import YG10K from '../../../../public/assets/front/images/findjewelry/10K-YG.webp'
import RG10K from '../../../../public/assets/front/images/findjewelry/10K-RG.webp'
import WG10K from '../../../../public/assets/front/images/findjewelry/10K.webp'

import YG14K from '../../../../public/assets/front/images/findjewelry/14K-YG.webp'
import RG14K from '../../../../public/assets/front/images/findjewelry/14K-RG.webp'
import WG14K from '../../../../public/assets/front/images/findjewelry/14K.webp'

import YG18K from '../../../../public/assets/front/images/findjewelry/18K-YG.webp'
import RG18K from '../../../../public/assets/front/images/findjewelry/18K-RG.webp'
import WG18K from '../../../../public/assets/front/images/findjewelry/18K.webp'

import G2T10K from '../../../../public/assets/front/images/findjewelry/10K-2T.webp'
import G2T14K from '../../../../public/assets/front/images/findjewelry/14K-2T.webp'
import G2T18K from '../../../../public/assets/front/images/findjewelry/18K-2T.webp'

import Silver from '../../../../public/assets/front/images/findjewelry/SS.webp'
import Platinum from '../../../../public/assets/front/images/findjewelry/PT.webp'
import Palladium from '../../../../public/assets/front/images/findjewelry/PD.webp'

export default {
  data(){
	return {
    rootClass: "vue-select-image",
    activeClass: "vue-select-image__thumbnail--selected",    
    h: '100px', 
    w: '100px',
    multipleSelected: [],
    limit: 0,
    apistates_url: window.apistates_url,
    metals:[],
    dataImages: [
      { id:  105, src: WG10K, metalclass: "10kwhitegold", alt: "10K White Gold", disabled: true}, 
      { id:  104, src: RG10K, metalclass: "10krosegold", alt: "10K Rose Gold", disabled: true}, 
      { id:  103, src: YG10K, metalclass: "10kyellowgold", alt: "10K Yellow Gold", disabled: true},         
      { id:  106, src: G2T10K, metalclass: "10k2tonegold", alt: "10K 2-Tone Gold", disabled: true},
      { id:  141, src: Silver, metalclass: "silver", alt: "Silver", disabled: true}, 
      { id:  102, src: WG14K, metalclass: "14kwhitegold", alt: "14K White Gold", disabled: true}, 
      { id:  101, src: RG14K, metalclass: "14krosegold", alt: "14K Rose Gold", disabled: true}, 
      { id:  100, src: YG14K, metalclass: "14Kyellowgold", alt: "14K Yellow Gold", disabled: true}, 
      { id:  134, src: G2T14K, metalclass: "14k2tonegold", alt: "14K 2-Tone Gold", disabled: true}, 
      { id:  140, src: Platinum, metalclass: "platinum", alt: "Platinum", disabled: true}, 
      { id:  137, src: WG18K, metalclass: "18kwhitegold", alt: "18K White Gold", disabled: true}, 
      { id:  136, src: RG18K, metalclass: "18krosegold", alt: "18K Rose Gold", disabled: true}, 
      { id:  135, src: YG18K, metalclass: "18kyellowgold", alt: "18K Yellow Gold", disabled: true}, 
      { id:  138, src: G2T18K, metalclass: "18k2tonegold", alt: "18K 2-Tone Gold", disabled: true}, 
      { id:  139, src: Palladium, metalclass: "palladium", alt: "Palladium", disabled: true}           
      ],
    model: {
      metal: '',
    },
    
    rules: {
      metal: [{
        required: true,
        message: 'Please select at least one jewelry metal.',
        trigger: 'change'
      }],
    }
	}},
  props: [
    'metalsdata',
  ],
  created() {
    this.URLparams();
  },
  methods: {
    URLparams() {
      const params = new URLSearchParams(window.location.search)

      const baseClass = `${this.rootClass}__thumbnail`;
      const activeClass = `${this.activeClass}`;

      this.model.metal = ( params.has('productMetals') 	? params.getAll('productMetals').toString() : '')

      var arr_metals = {}
        this.model.metal.split(',').forEach(element => {
          arr_metals = { 'id' : parseInt(element)}
      })
      this.multipleSelected = [].concat([ arr_metals ]);

      var parsedobj = this.model.metal.split(',')
      document.addEventListener("DOMContentLoaded", function() {
        parsedobj.forEach(element => {
          var typeClasses = `#m${element}` 
          var selection = document.querySelector(typeClasses) !== null;

          if ( selection )
            document.querySelector(typeClasses).classList.add("vue-select-image__thumbnail--selected") 
        });
      })
      return this.model
    },
    validate() {
      return new Promise((resolve, reject) => {
            this.$refs.form.validate((valid) => {
              this.$emit('on-validate', valid, this.model)
              resolve(valid);
            });
          })
    },
    onChange() {
      this.$emit("can-continue", { value: true });
    },
    classThumbnailMultiple(id, metalclass, isDisabled) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `_${metalclass} ${baseClass} is--multiple`;
      
			var typeClasses = `._${metalclass}` 
			var selection = document.querySelector(typeClasses) !== null;
      
      if (isDisabled) {
        if (selection) {
          if (document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`) ) {
            return `${baseMultipleClass} ${baseClass}--disabled`;
          }
        }          
      }
      if (this.isExistInArray(id) && !isDisabled) {
        if (selection) {
          if (!document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`) ) {
            return `${baseMultipleClass} ${this.activeClass}`;
          }
        }          
      }
      return `${baseMultipleClass}`;
    },
    isExistInArray(id) {
      return this.multipleSelected.find(item => {
        return id === item.id;
      });
    },
    removeFromMultipleSelected(id, dontFireEmit) {
      this.multipleSelected = this.multipleSelected.filter(item => {
        return id !== item.id;
      });
      if (!dontFireEmit) {
        this.$emit("onselectmultipleimage", this.multipleSelected);
      }
    },
    resetMultipleSelection() {
      this.multipleSelected = [];
    },
    onSelectMultipleImage(objectImage) {
      const baseClass = `${this.rootClass}__thumbnail`;
      const baseMultipleClass = `_${(objectImage.metalclass)} ${baseClass} is--multiple`;

      var typeClasses = `._${(objectImage.metalclass)}`
      //console.log(typeClasses)
      if (!document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`)) {
        objectImage.disabled = false
      } 

      if (!objectImage.disabled) {
        //console.log( " Stone not disabled.")
        if (!this.isExistInArray(objectImage.id)) {
          //console.log( " !isExistInArray.")
          if (this.limit > 0) {
            //console.log( " Limit > 0")           
            if (this.multipleSelected.length < this.limit) {
              //console.log( " Added: " + objectImage.datavalue)           
              this.multipleSelected.push(objectImage);
              this.$emit("onselectmultipleimage", this.multipleSelected);
            } else {
              this.$emit("onreachlimit", this.limit);
            }
          } else {
            //console.log( " First Addition: " + objectImage.datavalue)           
            this.multipleSelected.push(objectImage);
            this.$emit("onselectmultipleimage", this.multipleSelected);
          }
        } else {
          //console.log( " Removed: " + objectImage.datavalue)           
          this.removeFromMultipleSelected(objectImage.id, true);
          this.$emit("onselectmultipleimage", this.multipleSelected);
        }
      } else {
        //console.log(objectImage.stoneclass + ' has jewelry-disabled and cannot be selected.' )
      }      

      this.metals = [];
      var parsedobj = JSON.parse(JSON.stringify(this.multipleSelected))
      parsedobj.forEach(element => {
        if (!document.querySelector(typeClasses).classList.contains(`${baseClass}--disabled`)) {
          this.metals.push(element.id)
        }         
      });

      //removes extra prefix ","
      this.metals = this.metals.filter(function( element ) {
        return element !== null && element !== undefined;        
      }); 

      this.model.metal = JSON.parse(JSON.stringify(this.metals)).join(',')

    },    

  }

}
</script>

<style lang="scss" scoped>
	.vue-select-image__item {
		display: inline-block;
		padding: 5px 5px 3px 5px;
		margin: 5px;
		min-width: 35px;
		min-height: 35px;
		line-height: 37px;
		color: #333;
		text-decoration: none;
		text-align: center;
		background-color: #fff;
    float:none;
	}
</style>